import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=456a232c&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=456a232c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a232c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456a232c')) {
      api.createRecord('456a232c', component.options)
    } else {
      api.reload('456a232c', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=456a232c&scoped=true&", function () {
      api.rerender('456a232c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21TrLsfg678Pn/JS/comp/Paginate.vue"
export default component.exports